import { useMutation } from '@tanstack/react-query';

import {
  patchV1Subscriptions,
  type SubscriptionsInput,
} from '../../../api/generated/notification-pref';
import { getV1SubscriptionsQueryKey } from '../../../api/generated/notification-pref/@tanstack/react-query.gen';
import { queryClient } from '../../../api/queryClient';

/**
 * Mutation hooks for the Notification Preferences feature.
 *
 * Wraps the generated `@hey-api` SDK call (with `throwOnError`) and invalidates
 * the subscriptions query on success using the generated query key. Passing no
 * `query` to the key invalidates every aspect's subscriptions.
 */

export const useUpdateNotificationPreference = () =>
  useMutation({
    mutationFn: async (payload: {
      subscriptions: SubscriptionsInput;
      aspect: 'user' | 'identity' | undefined;
    }) => {
      const { data } = await patchV1Subscriptions({
        body: payload.subscriptions,
        query: { aspect: payload.aspect as 'user' | 'identity' | undefined },
        throwOnError: true,
      });
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: getV1SubscriptionsQueryKey() }),
  });
